import { render, staticRenderFns } from "./file-view-modal.vue?vue&type=template&id=a6c70066&scoped=true"
import script from "./file-view-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./file-view-modal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./file-view-modal.vue?vue&type=style&index=0&id=a6c70066&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6c70066",
  null
  
)

export default component.exports